// hooks/useBuscarMiembros.js
import { useEffect, useRef, useState } from "react"
import logger from "../utils/logger"
import { MemberService } from "../services/MemberService"

function useSearchMember(url,data) {
  const [dataToSearch, setDataToSearch] = useState(() => data ?? {})
  const [renderUsers, setRenderUsers] = useState([])
  const [loading, setLoading] = useState(false)

  const customData = useRef({
    PageSize: 10,
    PageIndex: 1,
    // HideReached:false
  })

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)
      try {
        const response = await MemberService.getMembers(dataToSearch, url)
        if (response.data) {

          // logger.warn('useSearchMember data: ', response.data)
          setRenderUsers(response.data)

          // setTimeout(() => {
          //   setLoading(false)
          // }, 1000);
          setLoading(false)
        }
      } catch (error) {
        // logger.error(error)
      } 
      // finally {
      //   setLoading(false)
      // }
    };

    fetchData();
  }, [dataToSearch])

  const handleObject = (object) => {

    //? Reseteo de paginado
    // const propiedadesAResetear = ["PageSize", "PageIndex"];

    // for (const key of propiedadesAResetear) {
    //   customData.current[key] = ""
    // }

    customData.current = {

      ...customData.current,
      ...object
    }

    // customData.current = object
    // logger.info('SE LLAMÓ A HANDLEOBJET()')

    logger.debug('👉 customData.current: ', customData.current)
    setDataToSearch(customData.current)
  };

  return {
    renderUsers,
    handleObject,
    loading,
    customData
  };
}

export default useSearchMember
